import React from 'react';
import { NodeGroup, NodeImage, NodeRect, NodeText } from './GraphNodeParts';
export const AppNode = ({ cfg }) => {
    var _a;
    const { height, name, path, width } = (_a = cfg.metadata) !== null && _a !== void 0 ? _a : {};
    const hasImage = Boolean(path);
    const maxHeight = cfg.large ? 56 : 28;
    return (React.createElement(NodeGroup, { capture: true, draggable: true },
        React.createElement(NodeRect, { draggable: true, keyshape: true, style: {
                flexDirection: 'row',
                padding: 10
            } },
            React.createElement(NodeRect, { draggable: true, style: {
                    cursor: 'pointer',
                    fill: '#FAFAFA',
                    justifyContent: 'center',
                    padding: [8, 6],
                    radius: 2,
                    stroke: '#D9D9D9',
                    width: 'auto'
                } },
                hasImage &&
                    React.createElement(NodeImage, { draggable: true, style: {
                            cursor: 'pointer',
                            filter: cfg.detected ? 'grayscale(80%)' : undefined,
                            height: maxHeight,
                            img: path !== null && path !== void 0 ? path : '',
                            width: (width || 1) * (maxHeight / (height || maxHeight))
                        } }),
                !hasImage &&
                    React.createElement(NodeText, { draggable: true, style: {
                            cursor: 'pointer',
                            fill: 'rgba(0,0,0,0.88)',
                            fontSize: cfg.large ? 48 : 24
                        } }, name)))));
};
